import { Button } from "@/components/ui/button";

interface CartFooterProps {
  calculateTotal: () => number;
  loading: boolean;
  cartItems: any[];
  digitalSignature: string;
  paymentMethod: string;
  onCancel: () => void;
  onValidate: () => void;
}

export const CartFooter = ({
  calculateTotal,
  loading,
  cartItems,
  digitalSignature,
  paymentMethod,
  onCancel,
  onValidate,
}: CartFooterProps) => {
  const isDisabled = loading || 
    !cartItems?.length || 
    !digitalSignature?.trim() || 
    !paymentMethod?.trim();

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex justify-between items-center">
        <span className="text-lg font-semibold">Total:</span>
        <span className="text-lg font-bold">{calculateTotal().toLocaleString()} FCFA</span>
      </div>
      <div className="flex justify-end space-x-4">
        <Button variant="outline" onClick={onCancel}>
          Annuler
        </Button>
        <Button 
          onClick={onValidate} 
          disabled={isDisabled}
        >
          {loading ? "Validation..." : "Valider le panier"}
        </Button>
      </div>
    </div>
  );
};